declare const __APP_VERSION__: string;

export function Footer() {
    return (
        <footer className="app-footer text-center py-2">
            <small className="text-muted">
                Version {__APP_VERSION__} by <a className="link-success" href="https://optazen.com">OptaZEN GmbH</a> 2026
            </small>
        </footer>
    );
}
